import { createContext, useContext } from 'react';

export interface SSEConnectionState {
  connected: boolean;
}

// Kept free of other imports: the assignment hook reads this context and the
// provider imports that hook's query documents, so anything heavier here would
// form an import cycle.
export const SSEContext = createContext<SSEConnectionState>({ connected: false });

/** Whether the per-user event stream is open. Consumers keep their poll as a fallback while it is not. */
export const useSSEConnection = (): SSEConnectionState => useContext(SSEContext);
